import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";

// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyDujE5-zCQxffnqByM9VXrjEsY7znEQLwc",
    authDomain: "sangram-patsanstha-web.firebaseapp.com",
    projectId: "sangram-patsanstha-web",
    storageBucket: "sangram-patsanstha-web.firebasestorage.app",
    messagingSenderId: "240190723783",
    appId: "1:240190723783:web:586a4a53e01e28848c10e2",
    measurementId: "G-7P2H1YDEST"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const db = getFirestore(app);
const auth = getAuth(app);
const storage = getStorage(app);

export { app, analytics, db, auth, storage };